import { push } from 'react-router-redux';
import { apiGet, apiPost } from './apiWrapper';
import { updateObject, isNullOrUndefined } from './storeFunctions';
import { languageChanged, userLogout } from './userContextStore';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value
const searchSubjectsRequest = "RELATIONS_SEARCH_SUBJECT_REQUEST";
export const searchSubjectsSucceeded = "RELATIONS_SEARCH_SUBJECT_SUCCEEEED";
export const searchSubjectsFailed = "RELATIONS_SEARCH_SUBJECT_FAILED";
const searchFormToggle = "RELATIONS_SEARCH_FORM_TOGGLE";
const basicSearchFormToggle = "RELATIONS_BASIC_SEARCH_FORM_TOGGLE";
const focusedQuickSearch = "RELATIONS_QUICK_SEARCH_FOCUSED";
const showQuickSearchResults = "RELATIONS_SHOW_QUICK_SEARCH_RESULTS";
const hideQuickSearchResults = "RELATIONS_HIDE_QUICK_SEARCH_RESULTS";
const changeEntityType = "RELATIONS_CHANGE_ENTITY_TYPE";
const setRelationSearchDomain = "RELATIONS_SET_RELATION_SEARCH_DOMAIN";
const setSearchParams = "RELATIONS_SET_SEARCH_PARAMS";
const setEntityId = "RELATIONS_SET_ENTITY_ID"
const setRelationsFilter = "RELATIONS_SET_FILTER";
const initFromLocalStorage = "RELATIONS_INIT_FROM_LOCAL_STORAGE";
export const hasSearchFilters = "SEARCH_FILTER_EXISTS";

export const searchStatus = {
    idle: 0,
    requested: 1,
    success: 2,
    error: 3
};

export const customSearchType = {
    linkAction: "linkAction",
    basicSearchLabels: "basicSearchLabels"
};

export const searchType = {
    QS: "qs",
    BS: "bs"
};

const initialCustomSearchState = {
    status: searchStatus.idle,
    data: null
};

const initialQuickSearchResultHidde = {
    navMenuDesktop: false,
    navMenuMobile: false,
    mainSearch: false
}

export const defaultPaging = {
    page: 1,
    count: 30,
    offset: 0
}

export const defaultOrderBy = {
    orderCol: "Relevance",
    orderDesc: true
}

export const searchInstances = {
    first: 'firstSearchInstance',
    second: 'secondSearchInstance',
    conflictOfInterest: 'conflictOfInterest',
    cre: 'cre',
    cee: 'cee',
    msp: 'msp',
    aml: 'aml'
}

export const searchInstancesWithSaveEnabled = [searchInstances.first, searchInstances.second];

const initialSearchInstanceState = {
    isSearching: false,
    searchPaging: { ...defaultPaging },
    searchParams: null,
    searchOrderBy: { ...defaultOrderBy },
    searchType: null,
    searchDomains: null,
    searchResult: null,
    formExpanded: true,
    basicFormExpanded: false,
    searchFilterHasData: false,
    error: null,
    focusInput: false,
    linkAction: { ...initialCustomSearchState },
    basicSearchLabels: { ...initialCustomSearchState },
    quickSearchResults: { ...initialQuickSearchResultHidde },
    isPo: true,
    languageChanged: false,
    searchFilter: {},
    clipboard: [],
    entityId: undefined
};

const initialState = {
    [searchInstances.first]: { ...initialSearchInstanceState },
    [searchInstances.second]: { ...initialSearchInstanceState },
    [searchInstances.conflictOfInterest]: { ...initialSearchInstanceState },
    [searchInstances.cre]: { ...initialSearchInstanceState },
    [searchInstances.cee]: { ...initialSearchInstanceState },
    [searchInstances.aml]: { ...initialSearchInstanceState },
    [searchInstances.msp]: { ...initialSearchInstanceState },
    relationsFilter: null
};

export const relationsSearchActions = {
    changePage: (searchInstance, page) => async (dispatch, getState) => changePage(searchInstance, page, dispatch, getState),
    repeatSearch: (searchInstance) => async (dispatch, getState) => repeatSearch(searchInstance, dispatch, getState),
    getRelationsSubjects: (searchInstance, searchType, params, paging, orderBy, domains) => async (dispatch, getState) => searchSubjects(searchInstance, searchType, params, paging || getState().relationsSearch[searchInstance].searchPaging, orderBy || getState().relationsSearch[searchInstance].searchOrderBy, domains || getState().relationsSearch[searchInstance].searchDomains, dispatch, getState),
    toggleForm: (searchInstance, value) => async (dispatch) => dispatch({ type: searchFormToggle, searchInstance: searchInstance, value: value }),
    toggleBasicForm: (searchInstance, value) => async (dispatch) => dispatch({ type: basicSearchFormToggle, searchInstance: searchInstance, value: value }),
    focusedQuickSearch: (searchInstance) => async (dispatch) => dispatch({ type: focusedQuickSearch, searchInstance: searchInstance }),
    showQuickSearchResults: (searchInstance, subId) => async (dispatch) => dispatch({ type: showQuickSearchResults, searchInstance: searchInstance, subId }),
    hideQuickSearchResults: (searchInstance, subId) => async (dispatch) => dispatch({ type: hideQuickSearchResults, searchInstance: searchInstance, subId }),
    triggerChangeEntityType: (searchInstance, value) => async (dispatch) => dispatch({ type: changeEntityType, searchInstance: searchInstance, value: value }),
    setRelationSearchDomain: (searchInstance, value) => async (dispatch) => dispatch({ type: setRelationSearchDomain, searchInstance: searchInstance, value: value }),
    setSearchParams: (searchInstance, params) => async (dispatch) => dispatch({ type: setSearchParams, searchInstance: searchInstance, params }),
    redirect: (url) => async (dispatch) => dispatch(push(url)),
    setEntityId: (searchInstance, entityId) => async(dispatch, getState) => saveEntityId(searchInstance, entityId, getState, dispatch),
    setRelationsFilter: (data) => async(dispatch) => dispatch({type: setRelationsFilter, relationsFilter: data}),
    initializeFromLocalStorage: (searchInstance) => async(dispatch) => dispatch({type: initFromLocalStorage, searchInstance: searchInstance})
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case LOCATION_CHANGE:
            return updateObject(state, { location: action.payload.pathname, quickSearchResults: { ...initialQuickSearchResultHidde } });
        case languageChanged:
            return { ...state, languageChanged: true };
        // Subject search
        case searchSubjectsRequest:
            return updateSearchInstanceState(state, action.searchInstance, {
                isSearching: true, searchParams: action.params, searchPaging: action.paging, searchType: action.searchType, searchDomains: action.domains, searchResult: null, error: null,
                basicSearchLabels: state.basicSearchLabels, linkAction: state.linkAction, languageChanged: false
            });
        case searchSubjectsSucceeded:
            return updateSearchInstanceState(state, action.searchInstance, { isSearching: false, searchResult: action.data, basicSearchLabels: state.basicSearchLabels, linkAction: state.linkAction });
        case searchSubjectsFailed:
            return updateSearchInstanceState(state, action.searchInstance, { isSearching: false, error: action.error, basicSearchLabels: state.basicSearchLabels, linkAction: state.linkAction });
        case searchFormToggle:
            return updateSearchInstanceState(state, action.searchInstance, { formExpanded: action.value });
        case basicSearchFormToggle:
            return updateSearchInstanceState(state, action.searchInstance, { basicFormExpanded: action.value });
        case hasSearchFilters:
            return updateSearchInstanceState(state, action.searchInstance, { searchFilterHasData: action.val });
        case focusedQuickSearch:
            return updateSearchInstanceState(state, action.searchInstance, { focusInput: false });
        case showQuickSearchResults:
            return updateSearchInstanceState(state, action.searchInstance, { quickSearchResults: { ...state.quickSearchResults, [action.subId]: true } });
        case hideQuickSearchResults:
            return updateSearchInstanceState(state, action.searchInstance, { quickSearchResults: { ...state.quickSearchResults, [action.subId]: false } });
        case changeEntityType:
            return updateSearchInstanceState(state, action.searchInstance, { isPo: action.value, quickSearchResults: { ...initialQuickSearchResultHidde } });
        case setRelationSearchDomain:
            return updateSearchInstanceState(state, action.searchInstance, { searchDomains: action.value });
        case userLogout:
            return updateSearchInstanceState(state, action.searchInstance, { searchParams: null })
        case setSearchParams:
            return updateSearchInstanceState(state, action.searchInstance, { searchParams: action.params })
        case setEntityId:
            return updateSearchInstanceState(state, action.searchInstance, { entityId: action.entityId })
        case setRelationsFilter: 
            if (!isNullOrUndefined(action.relationsFilter)) {
                let jsonData = JSON.stringify(action.relationsFilter);
                localStorage.setItem("relationsFilter", jsonData);
            }
            return updateObject(state, { relationsFilter: action.relationsFilter});  
        case initFromLocalStorage:
            let localStorageData = JSON.parse(localStorage.getItem(action.searchInstance));
            if (!isNullOrUndefined(localStorageData))   
                return updateSearchInstanceState(state, action.searchInstance, localStorageData);

            return { ...state };
        // None
        default:
            return state;
    }
}

function saveEntityId(searchInstance, entityId, getState, dispatch) {
    let jsonData = JSON.stringify(getState().relationsSearch[searchInstance]);
    localStorage.setItem(searchInstance, jsonData);
    dispatch({ type: setEntityId, searchInstance: searchInstance, entityId: entityId });
}

function changePage(searchInstance, page, dispatch, getState) {
    const oldState = getState().relationsSearch[searchInstance];
    const paging = { ...oldState.searchPaging, page, offset: (page - 1) * oldState.searchPaging.count };
    searchSubjects(searchInstance, oldState.searchType, oldState.searchParams, paging, oldState.searchOrderBy, oldState.searchDomains, dispatch, getState);
}

function repeatSearch(searchInstance, dispatch, getState) {
    const oldState = getState().relationsSearch[searchInstance];
    searchSubjects(searchInstance, oldState.searchType, oldState.searchParams, oldState.searchPaging, oldState.searchOrderBy, oldState.searchDomains, dispatch, getState);
}

function searchSubjects(searchInstance, searchType, params, paging, orderBy, domains, dispatch, getState) {
    dispatch({ type: searchSubjectsRequest, searchInstance: searchInstance, searchType: searchType, params, paging, domains });
    dispatch({ type: hasSearchFilters, searchInstance: searchInstance, val: false });
    if (searchType === "qs") {
        apiGet(`${window.babylonApiUrl}/api/search/quick`, { query: params.icoDic || params.name, offset: paging.offset, size: paging.count, type: params.isPo === true ? 1 : params.isPo === false ? 2 : null, dob: isNullOrUndefined(params.dob) ? null : params.dob },
            res => getState().relationsSearch[searchInstance].isSearching && dispatch({ type: searchSubjectsSucceeded, searchInstance: searchInstance, data: res }),
            err => dispatch({ type: searchSubjectsFailed, searchInstance: searchInstance, error: err })
        );
    }
    else if (searchType === "bs") {
        apiPost(`${window.babylonApiUrl}/api/search/basic`, {}, { ...params, ...paging, ...orderBy },
            res => {
                dispatch({ type: searchSubjectsSucceeded, searchInstance: searchInstance, data: res });
                dispatch({ type: hasSearchFilters, searchInstance: searchInstance, val: (res.data.filters !== null && res.data.filters !== undefined && res.data.filters.length > 0) });
            },
            err => dispatch({ type: searchSubjectsFailed, searchInstance: searchInstance, error: err })
        );
    }
    else {
        dispatch({ type: searchSubjectsFailed, searchInstance: searchInstance, error: `Unknown search type '${searchType}'` });
    }
}

function updateSearchInstanceState(state, searchInstance, update) {
    return state[searchInstance] ? { ...state, [searchInstance]: { ...state[searchInstance], ...update } } : state;
}
